import { WagtailStructBlock } from '@lacerta/wagtail';

export abstract class LacertaDynamicTypeComponent<T extends WagtailStructBlock | unknown> {
  context?: T;
  type?: string;
}
